import * as React from "react";
import { useCallback, useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { useValidateCache } from "components/lookup-tables/hooks/useLookupTablesAPI";
import { FormikFormGroup } from "components/common";
import CacheConfigFormFields from "./CacheConfigFormFields";
function CacheFormFields() {
  const { errors, values, touched, setValues, setErrors } = useFormikContext();
  const { validateCache } = useValidateCache();
  const configRef = useRef(null);
  const [generateName, setGenerateName] = useState(!values.title);
  const _sanitizeName = (inName) => inName.trim().replace(/\W+/g, "-").toLocaleLowerCase();
  const _runValidations = useCallback(() => {
    validateCache(values).then((resp) => {
      var _a, _b;
      const auxErrors = Object.keys(resp.errors).reduce((acc, key) => {
        if (errors[key]) acc[key] = errors[key];
        else acc[key] = resp.errors[key][0];
        return acc;
      }, {});
      const configErrors = ((_b = (_a = configRef == null ? void 0 : configRef.current) == null ? void 0 : _a.validate) == null ? void 0 : _b.call(_a)) || {};
      setErrors({ ...auxErrors, ...configErrors });
    });
  }, [validateCache, values, setErrors, errors]);
  const handleTitleChange = (event) => {
    if (!generateName) return;
    const safeName = _sanitizeName(event.target.value);
    setValues({
      ...values,
      title: event.target.value,
      name: safeName
    });
  };
  useEffect(() => _runValidations(), [_runValidations, values]);
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "title",
      label: "* Title",
      required: true,
      help: touched.title && errors.title ? null : "A short title for this cache.",
      onChange: handleTitleChange,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "description",
      label: "Description",
      help: "Cache description.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      type: "text",
      name: "name",
      label: "* Name",
      required: true,
      error: touched.name && errors.name ? errors.name : null,
      onChange: () => setGenerateName(!touched.name),
      help: touched.name && errors.name ? null : "The name that is being used to refer to this cache. Must be unique.",
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(CacheConfigFormFields, { ref: configRef, validationErrors: errors }));
}
export default CacheFormFields;
